var EPK = EPK || {};
EPK.ProductItemDetail = EPK.ProductItemDetail || {};
EPK.ProductItemDetail = function(){};

EPK.ProductCommon = EPK.ProductCommon || {};
EPK.ProductCommon = function(){};

EPK.ProductCommonParams = EPK.ProductCommonParams || {};

EPK.ProductItemDetailParams = EPK.ProductItemDetailParams || {};
EPK.ProductItemDetailParams.ECItemList = EPK.ProductItemDetailParams.ECItemList || {};

/*
EPK.ProductItemDetail.prototype.setBalloonElsStyle = function(){

	Array.prototype.forEach.call(document.querySelectorAll('.point-baloon'),function(el) {
		var textEl = el.querySelector('.text');

		if(textEl && textEl.scrollHeight < 16) {
			var allEl = el.querySelector('.all');
			var inputEl = el.querySelector('input');
			if(allEl) allEl.style.display = 'none';
			if(inputEl) inputEl.disabled = true;
			textEl.style.textAlign = 'center';
			textEl.style.width = '100%';
		}
	});

};
*/

/**
 * <SP版商品詳細用>
 * 店頭で購入タブ「標準」がクリックされた
 */
EPK.ProductItemDetail.prototype.getSortNormal = function() {
	// 近い順パラメータ判定
	var path = location.pathname;
	var pathArray = path.split('/');
	var params = {};
	if (location.search) {
		var query = location.search.replace('?', '');
		var makers = query.split('&');
		for (i in makers) {
			var array = makers[i].split('=');
			params[array[0]] = array[1];
		}
	}

	var url = location.origin + location.pathname;
	var param;
	var paramAdd = '';

	if(params.is_torioki){
		paramAdd = '&is_torioki=1';
	}
	if(params.is_pos){
		paramAdd += '&is_pos=1';
	}

	if(params.lat && params.lng){
		param = '?lat=' + params.lat + '&lng=' + params.lng + '&sort=normal' + paramAdd;
	}else{
		param = '?sort=normal' + paramAdd;
	}

	location.href = url + param;
};

/**
 * 現在地（緯度経度）取得処理
 * ※※位置情報取得できない場合のハンドリングが必要なので
 * ※※共通処理(EPK.common.currentPlaceCallback)は利用しない
 *
 */
EPK.ProductItemDetail.prototype.getLocation = function() {
	// 近い順パラメータ判定
	var path = location.pathname;
	var pathArray = path.split('/');
	var params = {};
	if (location.search) {
		var query = location.search.replace('?', '');
		var makers = query.split('&');
		for (i in makers) {
			var array = makers[i].split('=');
			params[array[0]] = array[1];
		}
	}

	var paramAdd = '';

	// 他画面からの初回アクセス時
	if (!Object.keys(params).length && pathArray.length == 4) {
		if (EPK.ProductItemDetailParams.pageAttribute) {
			switch (EPK.ProductItemDetailParams.pageAttribute) {
				case 2:
				case 3:
					paramAdd = '&is_torioki=1';
					break;

				default:
					break;
			}
		}
	} else {
		if(params.is_torioki){
			paramAdd = '&is_torioki=1';
		}
		if(params.is_pos){
			paramAdd += '&is_pos=1';
		}
	}

	function successFunc(position) {
		var $data = position.coords ;
		var $lat = $data.latitude;
		var $lng = $data.longitude;

		// 絞り込みが無い（URLが「.com/product/item/商品ID」）か緯度経度がパラメータにない場合は
		// 緯度経度・必要なパラメータを付加してリダイレクト
		if ((!Object.keys(params).length || !params.lat || !params.lng) && pathArray.length == 4) {
			if(params.sort != 'normal'){
				redirect(path, $lat, $lng, paramAdd);
			}
		}

		$('#sort_close').on('click.sort_close', function() {
			redirect(path, $lat, $lng, paramAdd);
		});

		doAttributeParams($lat, $lng);
	}

	function redirect(path, lat, lng, paramAdd) {
		location.href = location.origin + path + '?lat=' + lat + '&lng=' + lng + '&sort=close' + paramAdd;
	}

	var errorInfo = [
		"原因不明のエラーが発生しました。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"位置情報が正しく計測されませんでした。圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。有効に設定後は、ページを「更新」あるいは「再読み込み」してください。",
		"電波状況などで位置情報が取得できませんでした。電波状況のいいところで再度お試しください。",
		"位置情報の取得に時間がかかり過ぎてタイムアウトしました。電波状況のいいところで再度お試しください。"
	];
	function errorFunc(error) {
		if(EPK.ProductItemDetailParams.isSP){
			if(EPK.ProductItemDetailParams.sort != 'normal'){
				// 近い順指定で現在地が取得出来ない場合は標準検索とする
				EPK.ProductItemDetailParams.sort = 'normal';

				var url = location.origin + path + '?sort=normal&location_ng=1' + paramAdd;
				location.href = url;
			} else {
				$('#sort_close').off('click.sort_close');
				$('#sort_close').on('click.sort_close', function() {
					// エラーコード(error.code)の番号
					// 0:UNKNOWN_ERROR				原因不明のエラー
					// 1:PERMISSION_DENIED			利用者が位置情報の取得を許可しなかった
					// 2:POSITION_UNAVAILABLE		電波状況などで位置情報が取得できなかった
					// 3:TIMEOUT					位置情報の取得に時間がかかり過ぎた…
					console.error(error);
					// エラーメッセージ
					var errorMessage = errorInfo[error.code];
					alert(errorMessage);
				});
			}
		}
	}

	function doAttributeParams(lat, lng) {
		if(EPK.ProductItemDetailParams.isSP){
			var href = $('.detail-item-info .item-sub a').prop('href');

			// メーカー名リンク生成
			$('.detail-item-info .item-sub a').prop('href', href + '?lat=' + lat + '&lng=' + lng + '&sort=close');
		}
	}

	var tmpLat = Cookies.get('lat');
	var tmpLng = Cookies.get('lng');
	if(tmpLat && tmpLng) {
		successFunc({coords: {latitude: tmpLat*1.0, longitude: tmpLng*1.0}});
		return;
	}

	var optionObj = {
		"enableHighAccuracy": true,
		"timeout": 8000,
		"maximumAge": 2000,
	};

	// Geolocation APIの対応判定
	if(navigator.geolocation) {
		// 現在位置を取得
		navigator.geolocation.getCurrentPosition(
			// [第1引数] 取得に成功した場合の関数
			function(position){
				var data = position.coords ;
				var lat = data.latitude;
				var lng = data.longitude;

				EPK.common.latlng.lat = lat;
				EPK.common.latlng.lng = lng;

				successFunc(position);
			},
			// [第2引数] 取得に失敗した場合の関数
			errorFunc.bind(this),

			// [第3引数] オプション
			{
				"enableHighAccuracy": false,
				"timeout": 8000,
				"maximumAge": 2000,
			}
		)
	}else {
		errorFunc();
	}
};

EPK.ProductItemDetail.prototype.setAffiliateInfo = function() {
	if (!checkPage()) {
		return;
	}

	var janCode = EPK.ProductItemDetailParams.jan_code;
	if (janCode === undefined || janCode == '') {
		return;
	}

	var deployPoint = getDeployPoint();
	if (!(deployPoint.length)) {
		return;
	}

	callApi(janCode).done(function(data) {
		deployPoint.prepend(data);

		// API 情報含めて変換する為完了時にのみ読み込み
		loadValuecommerceJs();
	});

	function checkPage() {
		if (EPK.common.isMobile) {
			return true;
		}

		var page = getPage();
		return page <= 1;
	}

	function getPage() {
		url = window.location.href;
		paramName = 'p';

		var regex   = new RegExp("[?&]" + paramName + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return 1;
		if (!results[2]) return 1;
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	function getDeployPoint() {
		var deployPoint;
		if (EPK.ProductItemDetailParams.isSP) {
			deployPoint = $("div.purchase-storelist > ul");
		} else {
			deployPoint = $("div.advertising");
		}
		return deployPoint;
	}

	function callApi(janCode) {
		var itemId = EPK.ProductItemDetailParams.itemId;

		return $.ajax({
			type: 'POST',
			url: '/api/affiliate/get_item_list_html',
			data: {
				"jan_code": janCode,
				"item_id" : itemId,
				"isMobile": EPK.common.isMobile ? true : false,
			},
			cache: true,
			timeout: 60000,
			dataType: "html",
		});
	}

	function loadValuecommerceJs() {
		var setVcPid = document.createElement('script');
		setVcPid.textContent = 'var vc_pid = "886882149";';
		document.body.appendChild(setVcPid);

		var loadJs = document.createElement('script');
		loadJs.src = "//aml.valuecommerce.com/vcdal.js";
		document.body.appendChild(loadJs);
	}
}

/**
 * PC版　メーカーリスト取得
 *
 */
/*
EPK.ProductItemDetail.prototype.getMakerList = function() {
	if(EPK.ProductItemDetailParams.isSP){
		return;
	}

	var el = document.getElementById('menu_maker');
	if (!el) {
		return;
	}

	var category_path = el.dataset.category_path;
	if (!category_path) {
		return;
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/maker/' + category_path,
		cache: false,
		dataType : 'json',
	}).done(
		function(data) {
			// メーカーリスト表示
			if (data['menu']) {
				var menuEl = document.getElementById('menu_maker');
				menuEl.insertAdjacentHTML('afterend', data['menu']);
			}
			if (data['modal']) {
				var modalEl = document.getElementById('modal_stock_num');
				modalEl.insertAdjacentHTML('afterend', data['modal']);
			}

			// 「メーカーを選択する」モーダル
			if (data['menu'] && data['modal']) {
				$('#modal_makerlist_link').on('click', function (event) {
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {src: '#modal_makerlist'},
						type: 'inline',
						modal: false,
						showCloseBtn: false
					}, 0);
				});
			}
		}
	).fail(
		function(data) {
			console.log(data);
		}
	);
};
*/

/**
 * PC版　カテゴリーレコメンド取得
 *
 */
/*
EPK.ProductItemDetail.prototype.getCategoryRecommendList = function() {
	if(EPK.ProductItemDetailParams.isSP){
		return;
	}

	var item_id = location.pathname.replace('/product/item/', '');
	var el = document.getElementById('menu_maker');
	if (!el) {
		return;
	}
	var category_path = el.dataset.category_path;

	if (!item_id || !category_path) {
		return;
	}

	var dispPrice = EPK.ProductItemDetailParams.dispPrice;

	$.ajax({
		type: 'POST',
		url: '/api/product/recommend',
		cache: false,
		dataType : 'HTML',
		data: {
			item_id: item_id,
			category_path: category_path,
			debug_disp_price: EPK.ProductItemDetailParams.dispPrice
		}
	}).done(
		function(data) {
			if (data){
				mainEl = document.querySelector('.main-contents');
				mainEl.insertAdjacentHTML('beforeend', JSON.parse(data));
				$('.recommend-slide').swiper({
					loop: true,
					spaceBetween: 20,
					slidesPerView: 7,
					initialSlide: 0,
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					preloadImages: true,
				});
			}
		}
	).fail(
		function(data) {
			console.log(data);
		}
	);
};
*/

/**
 * ・セット購入なら『ポイント交換クーポン』対応！
 * ・会員限定 EPARKポイント 交換 ◯ 円OFFクーポン
 * ・クーポン価格 ◯円（税込）
 * ・販売価格 ◯円（税込）
 * ・通常価格 ◯円（税込）
 * ・セット数切り替えボタン
 * ・おいトクサービス対応店舗あります
 * SP版はスライダー処理と直列にするためDeferredを使用
 */
EPK.ProductItemDetail.prototype.setItemMinPriceAreaSp = function() {
	itemMinPriceArea = document.getElementById('item_min_price_area');
	if(!itemMinPriceArea){
		return;
	}

	var itemId = EPK.ProductItemDetailParams.itemId;
	if(!itemId){
		return;
	}

	oitokuShoptextArea = document.getElementById('oitoku_shoptext_area');
	oitokuArea = document.getElementById('oitoku_area');
	oitokuSubArea = document.getElementById('oitoku_sub_area');

	var deferred = new $.Deferred;

	$.ajax({
		type: 'POST',
		url: '/api/product/set_item_min_price_area',
		data: {
				'item_id': itemId,
				'lat': EPK.ProductItemDetailParams.lat,
				'lng': EPK.ProductItemDetailParams.lng,
				'pref_cd': EPK.ProductItemDetailParams.prefCd,
				'area_id': EPK.ProductItemDetailParams.areaId,
				'station_cd': EPK.ProductItemDetailParams.stationCd,
				'same_group_item_list': EPK.ProductItemDetailParams.sameGroupItemList,
				'debug_disp_price': EPK.ProductItemDetailParams.dispPrice
			},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data){
		if(data.length){
			$(itemMinPriceArea).after(data);

			/*
			 * 通販サイト:商品リスト取得
			 */
			//if(EPK.ProductItemDetailParams.ECItemList.request && EPK.ProductItemDetailParams.ECItemList.price > 0) {
			//	var reProductItemDetail = new EPK.ProductItemDetail();
			//	reProductItemDetail.getECItemList();
			//	//console.log(EPK.ProductItemDetailParams.ECItemList);
			//}

			//var $dispChangeAreaButtonArea = $('#disp_change_area_button_area');
			//if($dispChangeAreaButtonArea.length){
			//	$dispChangeAreaButtonArea.attr('href', EPK.ProductItemDetailParams.researchUrl);
			//	$('#change_area_button_area').append($dispChangeAreaButtonArea);
			//}

			if(document.getElementById('change_lot_button_area')){
				var changeLotButtonAsyncArea = document.getElementsByClassName('change_lot_button_async_area');
				var changeLotButtonAsyncElement = document.getElementsByClassName('change_lot_button_async_element');

				if(changeLotButtonAsyncArea.length > 0 && changeLotButtonAsyncElement.length > 0){
					[].forEach.call(changeLotButtonAsyncArea, function(el1, index1) {
						changeLotButtonAsyncAreaItemId = el1.getAttribute('data-item_id');

						[].forEach.call(changeLotButtonAsyncElement, function(el2, index2) {
							changeLotButtonAsyncElementItemId = el2.getAttribute('data-item_id');

							if(changeLotButtonAsyncAreaItemId == changeLotButtonAsyncElementItemId){
								el2.style.display = '';
								el1.insertAdjacentElement('beforeend', el2);
							}
						});
					});
				}
			}

			setOitokuSubArea = document.getElementById('set_oitoku_sub_area');
			setOitokuShoptext = document.getElementById('set_oitoku_shoptext');

			if (oitokuSubArea && setOitokuSubArea) {
				$(oitokuSubArea).after(setOitokuSubArea);
			}

			if (setOitokuShoptext) {
				$(oitokuShoptextArea).after(setOitokuShoptext);
			}
		}

		itemMinPriceArea.remove();

		if (oitokuShoptextArea) {
			$(oitokuShoptextArea).remove();
		}

		if (oitokuSubArea) {
			$(oitokuSubArea).remove();
		}

		if (oitokuArea && oitokuArea.childElementCount == 0) {
			$(oitokuArea).remove();
		}

		itemReceivableDateArea = document.getElementById('item_receivable_date_area');
		if(!itemReceivableDateArea){
			deferred.resolve();

			return true;
		}

		$.ajax({
			type: 'POST',
			url: '/api/product/set_item_receivable_date_area',
			data: {
					'item_id': itemId,
					'lat': EPK.ProductItemDetailParams.lat,
					'lng': EPK.ProductItemDetailParams.lng,
					'pref_cd': EPK.ProductItemDetailParams.prefCd,
					'area_id': EPK.ProductItemDetailParams.areaId,
					'station_cd': EPK.ProductItemDetailParams.stationCd
				},
			cache: false,
			dataType : 'html',
			timeout: 50000
		}).done(function(data){
			if(data.length){
				$(itemReceivableDateArea).after(data);
			}

			itemReceivableDateArea.remove();

		}).fail(function(data){
			console.log('failed');
			console.log(data);

			itemReceivableDateArea.remove();

			deferred.reject();

			return false;
		});

		deferred.resolve();

		return true;
	}).fail(function(data){
		console.log('failed');
		console.log(data);

		itemMinPriceArea.remove();

		deferred.reject();

		return false;
	});

	return deferred.promise();
};


/**
 * ・セット購入なら『ポイント交換クーポン』対応！
 * ・会員限定 EPARKポイント 交換 ◯ 円OFFクーポン
 * ・クーポン価格 ◯円（税込）
 * ・販売価格 ◯円（税込）
 * ・通常価格 ◯円（税込）
 * ・セット数切り替えボタン
 * ・おいトクサービス対応店舗あります
 * の取得と表示
 * SP版はスライダー処理と直列処理にする為分ける
 */
 EPK.ProductItemDetail.prototype.setItemMinPriceAreaPc = function() {
	itemMinPriceArea = document.getElementById('item_min_price_area');
	if(!itemMinPriceArea){
		return;
	}

	var itemId = EPK.ProductItemDetailParams.itemId;
	if(!itemId){
		return;
	}

	oitokuArea = document.getElementById('oitoku_area');

	$.ajax({
		type: 'POST',
		url: '/api/product/set_item_min_price_area',
		data: {
				'item_id': itemId,
				'lat': EPK.ProductItemDetailParams.lat,
				'lng': EPK.ProductItemDetailParams.lng,
				'pref_cd': EPK.ProductItemDetailParams.prefCd,
				'area_id': EPK.ProductItemDetailParams.areaId,
				'station_cd': EPK.ProductItemDetailParams.stationCd,
				'same_group_item_list': EPK.ProductItemDetailParams.sameGroupItemList,
				'debug_disp_price': EPK.ProductItemDetailParams.dispPrice
			},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data){
		if(data.length){
			$(itemMinPriceArea).after(data);

			if(document.getElementById('change_lot_button_area')){
				var changeLotButtonAsyncArea = document.getElementsByClassName('change_lot_button_async_area');
				var changeLotButtonAsyncElement = document.getElementsByClassName('change_lot_button_async_element');

				if(changeLotButtonAsyncArea.length > 0 && changeLotButtonAsyncElement.length > 0){
					[].forEach.call(changeLotButtonAsyncArea, function(el1, index1) {
						changeLotButtonAsyncAreaItemId = el1.getAttribute('data-item_id');

						[].forEach.call(changeLotButtonAsyncElement, function(el2, index2) {
							changeLotButtonAsyncElementItemId = el2.getAttribute('data-item_id');

							if(changeLotButtonAsyncAreaItemId == changeLotButtonAsyncElementItemId){
								el2.style.display = '';
								el1.insertAdjacentElement('beforeend', el2);
							}
						});
					});
				}
			}

			setOitokuArea = document.getElementById('set_oitoku_area');

			if (oitokuArea && setOitokuArea) {
				// IE対応
				oitokuArea.insertAdjacentElement('afterend', setOitokuArea);
			}
		}

		itemMinPriceArea.remove();

		if (oitokuArea && oitokuArea.childElementCount == 0) {
			// IE対応
			oitokuArea.parentNode.removeChild(oitokuArea);
		}

		itemReceivableDateArea = document.getElementById('item_receivable_date_area');
		if(!itemReceivableDateArea){
			return true;
		}

		$.ajax({
			type: 'POST',
			url: '/api/product/set_item_receivable_date_area',
			data: {
					'item_id': itemId,
					'lat': EPK.ProductItemDetailParams.lat,
					'lng': EPK.ProductItemDetailParams.lng,
					'pref_cd': EPK.ProductItemDetailParams.prefCd,
					'area_id': EPK.ProductItemDetailParams.areaId,
					'station_cd': EPK.ProductItemDetailParams.stationCd
				},
			cache: false,
			dataType : 'html',
			timeout: 50000
		}).done(function(data){
			if(data.length){
				$(itemReceivableDateArea).after(data);
			}

			itemReceivableDateArea.remove();
		}).fail(function(data){
			console.log('failed');
			console.log(data);

			itemReceivableDateArea.remove();

			return false;
		});

		if (setOitokuArea && setOitokuArea.childElementCount == 0) {
			// IE対応
			setOitokuArea.parentNode.removeChild(setOitokuArea);
		}

		return true;
	}).fail(function(data){
		console.log('failed');
		console.log(data);

		itemMinPriceArea.remove();

		return false;
	});
};

/**
 * SP版　通販サイト商品リスト取得
 */
/*
EPK.ProductItemDetail.prototype.getECItemList = function() {

	var container = document.getElementById('ec-item-list-container');
	if(!container) {
		return;
	}

	if(!EPK.ProductItemDetailParams.ECItemList.name) {
		container.style.display="none";
		return;
	}
	if(!EPK.ProductItemDetailParams.ECItemList.price) {
		container.style.display="none";
		return;
	}

	$.ajax({
		type: 'POST',
		url: '/api/product/ec/item',
		cache: false,
		dataType : 'HTML',
		data: {
			name: EPK.ProductItemDetailParams.ECItemList.name,
			min_price: EPK.ProductItemDetailParams.ECItemList.price,
		}
	}).done(
		function(data) {
			if (data){
				container.innerHTML = data;
			}else {
				container.style.display="none";
			}
		}
	).fail(
		function(data) {
			container.style.display="none";
			//console.log(data);
		}
	);
};
*/

/**
 * <SP版商品詳細用>
 * 商品バリエーションの取得と表示
 */
/*
EPK.ProductItemDetail.prototype.setItemGroupArea = function() {
	if(!EPK.ProductItemDetailParams.isSP){
		return;
	}

	var $itemGroupArea = $('#item_group_area');
	if(!$itemGroupArea.length){
		return;
	}

	var itemId = EPK.ProductItemDetailParams.itemId;
	if(!itemId){
		return;
	}

	$.ajax({
		type: 'POST',
		url: '/api/product/set_item_group_area',
		data: {
				'item_id': itemId,
				'lat': EPK.ProductItemDetailParams.lat,
				'lng': EPK.ProductItemDetailParams.lng,
				'pref_cd': EPK.ProductItemDetailParams.prefCd,
				'area_id': EPK.ProductItemDetailParams.areaId,
				'station_cd': EPK.ProductItemDetailParams.stationCd
			},
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data){
		if(data.length){
			$itemGroupArea.after(data);
			EPK.ProductItemDetail.addUrlParamItemGroup();
		}

		$itemGroupArea.remove();

		return true;
	}).fail(function(data){
		console.log('failed');
		console.log(data);

		$itemGroupArea.remove();

		return false;
	});
};
*/

/**
 * <SP版商品詳細用>
 * 商品バリエーション画像のリンク加工
 */
/*
EPK.ProductItemDetail.addUrlParamItemGroup = function() {
	var lat = EPK.ProductItemDetailParams.lat;
	var lng = EPK.ProductItemDetailParams.lng;
	var sort = EPK.ProductItemDetailParams.sort;

	var param = '?lat=' + lat + '&lng=' + lng + '&sort=' + sort;

	$('#disp_item_group_area a').each(function(index, value){
		$(this).prop('href', value + param);
	});
};
*/

/**
 * <SP版商品詳細用>
 * 「店頭で購入 > 店舗の在庫状況 > もっと見る」ボタンクリック
 */
EPK.ProductItemDetail.prototype.showMoreItemShopList = function(event){
	if(!EPK.ProductItemDetailParams.isSP){
		return;
	}

	var _this = this;
	var objSection = $('#stock_exist_shop_list');
	var more = $('#morebtn_shop_item_list');
	var moreLoging = $('#morebtn_shop_item_list_loading');
	var itemId = EPK.ProductItemDetailParams.itemId;
	var page = more.children('a').attr('target-page');
	var sort = more.children('a').attr('sort');
	var lat = EPK.ProductItemDetailParams.lat;
	var lng = EPK.ProductItemDetailParams.lng;
	var prefCd = EPK.ProductItemDetailParams.prefCd;
	var areaId = EPK.ProductItemDetailParams.areaId;
	var stationCd = EPK.ProductItemDetailParams.stationCd;
	var dispPrice = EPK.ProductItemDetailParams.dispPrice;
	var isPos = EPK.ProductItemDetailParams.isPos;
	var isTorioki = EPK.ProductItemDetailParams.isTorioki;

	//ボタン読み込み切り替え
	more.remove();
	moreLoging.show();

	var url = '/api/product/get_shop_item_list';
	url += '?item_id=' + itemId + '&p=' + page + '&sort=' + sort;

	if(prefCd){
		url += '&pref_cd=' + prefCd;
	}
	if(areaId){
		url += '&area_id=' + areaId;
	}
	if(stationCd){
		url += '&station_cd=' + stationCd;
	}
	if (lat && lng) {
		url += '&lat=' + lat + '&lng=' + lng;
	}
	if(dispPrice){
		url += '&debug_disp_price=' + dispPrice;
	}
	if(isPos){
		url += '&is_pos=' + isPos;
	}
	if(isTorioki){
		url += '&is_torioki=' + isTorioki;
	}

	$.ajax({
		type: 'GET',
		url: url,
		cache: false,
		dataType : 'html',
		data: {
		}
	}).done(
		function(data, textStatus, jqXHR) {
			//console.log(data);
			//console.log(textStatus);
			//console.log(jqXHR);
			if (data && textStatus == 'success') {
				more.remove();
				moreLoging.remove();
				objSection.append(data);

				_this.initProductShopItemListSp();

				/*
				//リクエストボタンの描画
				var zaikoShop = document.querySelectorAll('.zaiko-request[target-shop-id]');
				var toriokiShop = document.querySelectorAll('.torioki-request[target-shop-id]');
				var zaikoRequestShopId = []
				var toriokiRequestShopId = []

				for (var i = 0; i < zaikoShop.length; i++) {
					if (zaikoShop[i].children.length == 0) {
						zaikoRequestShopId.push(zaikoShop[i]);
					}
				}

				for (var i = 0; i < toriokiShop.length; i++) {
					if (toriokiShop[i].children.length == 0) {
						toriokiRequestShopId.push(toriokiShop[i]);
					}
				}

				if (toriokiRequestShopId.length > 0) {
					_this.renderRequestBtn('1',toriokiRequestShopId,'torioki')
				}
				if (zaikoRequestShopId.length > 0) {
					_this.renderRequestBtn('2',zaikoRequestShopId,'zaiko');
				}
				*/
			} else {
				more.remove();
				moreLoging.remove();
			}
		}
	).fail(
		function(data) {
			console.log('fail');
		}
	);
};

/**
 * #14912
 * 店舗リストの非同期取得
 */
 EPK.ProductItemDetail.prototype.getItemShopList = function(event){
	if(!EPK.ProductItemDetailParams.isSP){
		return;
	}

	var _this = this;
	var itemslide = $('#other-itemslide-async');
	var itemId = EPK.ProductItemDetailParams.itemId;
	var page = 1;
	var sort = EPK.ProductItemDetailParams.sort;
	var lat = EPK.ProductItemDetailParams.lat;
	var lng = EPK.ProductItemDetailParams.lng;
	var prefCd = EPK.ProductItemDetailParams.prefCd;
	var areaId = EPK.ProductItemDetailParams.areaId;
	var stationCd = EPK.ProductItemDetailParams.stationCd;
	var dispPrice = EPK.ProductItemDetailParams.dispPrice;
	var isPos = EPK.ProductItemDetailParams.isPos;
	var isTorioki = EPK.ProductItemDetailParams.isTorioki;

	var url = '/api/product/get_shop_item_list_initdisplay';
	url += '?item_id=' + itemId + '&p=' + page + '&sort=' + sort;

	if(prefCd){
		url += '&pref_cd=' + prefCd;
	}
	if(areaId){
		url += '&area_id=' + areaId;
	}
	if(stationCd){
		url += '&station_cd=' + stationCd;
	}
	if (lat && lng) {
		url += '&lat=' + lat + '&lng=' + lng;
	}
	if(dispPrice){
		url += '&debug_disp_price=' + dispPrice;
	}
	if(isPos){
		url += '&is_pos=' + isPos;
	}
	if(isTorioki){
		url += '&is_torioki=' + isTorioki;
	}

	var deferred = new $.Deferred;
	$.ajax({
		type: 'GET',
		url: url,
		cache: false,
		dataType : 'html',
		data: {
		}
	}).done(
		function(data, textStatus, jqXHR) {
			//console.log(data);
			//console.log(textStatus);
			//console.log(jqXHR);
			if (data && textStatus == 'success') {

				itemslide.after(data);

				/*
				//リクエストボタンの描画
				var zaikoShop = document.querySelectorAll('.zaiko-request[target-shop-id]');
				var toriokiShop = document.querySelectorAll('.torioki-request[target-shop-id]');
				var zaikoRequestShopId = []
				var toriokiRequestShopId = []

				for (var i = 0; i < zaikoShop.length; i++) {
					if (zaikoShop[i].children.length == 0) {
						zaikoRequestShopId.push(zaikoShop[i]);
					}
				}

				for (var i = 0; i < toriokiShop.length; i++) {
					if (toriokiShop[i].children.length == 0) {
						toriokiRequestShopId.push(toriokiShop[i]);
					}
				}

				if (toriokiRequestShopId.length > 0) {
					_this.renderRequestBtn('1',toriokiRequestShopId,'torioki')
				}
				if (zaikoRequestShopId.length > 0) {
					_this.renderRequestBtn('2',zaikoRequestShopId,'zaiko');
				}
				*/
			}
			deferred.resolve(data);
		}
	).fail(
		function(data) {
			console.log('fail');
			deferred.resolve(data);
		}
	);
	return deferred.promise();
};


/**
 * <SP版商品詳細用>
 * 「店頭で購入 > ブランドの取り扱いがある店舗 > もっと見る」ボタンクリック
 */
/*
EPK.ProductItemDetail.prototype.showMoreItemBrandShopList = function(event){
	if(!EPK.ProductItemDetailParams.isSP){
		return;
	}

	var _this = this;
	var objSection = $('#item_brand_shop_list');
	var more = $('#morebtn_item_brand_shop_list');
	var itemId = EPK.ProductItemDetailParams.itemId;
	var page = more.children('a').attr('target-page');
	var sort = more.children('a').attr('sort');
	var lat = EPK.ProductItemDetailParams.lat;
	var lng = EPK.ProductItemDetailParams.lng;
	var prefCd = EPK.ProductItemDetailParams.prefCd;
	var areaId = EPK.ProductItemDetailParams.areaId;
	var stationCd = EPK.ProductItemDetailParams.areaId;
	var ephcItemBrandId = EPK.ProductItemDetailParams.ephcItemBrandId;

	var url = '/api/product/get_item_brand_shop_list';
	url += '?p2=' + page + '&sort=' + sort;

	if(ephcItemBrandId){
		url += '&ephc_brand_id=' + ephcItemBrandId;
	}
	if(prefCd){
		url += '&pref_cd=' + prefCd;
	}
	if(areaId){
		url += '&area_id=' + areaId;
	}
	if(stationCd){
		url += '&station_cd=' + stationCd;
	}
	if (lat && lng) {
		url += '&lat=' + lat + '&lng=' + lng;
	}

	more.remove();

	$.ajax({
		type: 'GET',
		url: url,
		cache: false,
		dataType : 'html',
		data: {
		}
	}).done(
		function(data, textStatus, jqXHR) {
			//console.log(data);
			//console.log(textStatus);
			//console.log(jqXHR);
			if (data && textStatus == 'success') {
				more.remove();
				objSection.append(data);

				_this.initItemBrandShopListSp();
			} else {
				more.remove();
			}
		}
	).fail(
		function(data) {
			console.log('fail');
		}
	);
};
*/

/**
 * <SP版商品詳細用>
 * 「店頭で購入 > 店舗の在庫状況」リストの初期化
 */
EPK.ProductItemDetail.prototype.initProductShopItemListSp = function(){
    var _this = this;

    $('#morebtn_shop_item_list').on('click', function(event){
        _this.showMoreItemShopList(event);
    });

	$('.modal-product-item-stock-num-btn').on('click', function(event) {
		event.preventDefault();
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: $('#modal-product-item-stock-num')},
			type: 'inline',
			modal: false,
			showCloseBtn: false
		}, 0);
	});

	$('.modal-product-item-stock-btn-sp').on('click', function(event) {
		event.preventDefault();

		$('#modal-product-item-stock-num-tel').text($(this).data('tel'));
		$('#modal-product-item-stock-num-opentime').text($(this).data('opentime'));
		$('#modal-product-item-stock-num-shopname').text($(this).data('shopname'));
		$('#modal-product-item-stock-num-holiday').text($(this).data('holiday'));
		$('#modal-product-item-stock-num-tel-href').prop('href', 'tel:' + $(this).data('tel'));

		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: $('#modal-product-item-stock')},
			type: 'inline',
			modal: false,
			showCloseBtn: false
		}, 0);
	});
};

/**
 * <SP版商品詳細用>
 * 「店頭で購入 > ブランドの取り扱いがある店舗」リストの初期化
 */
/*
EPK.ProductItemDetail.prototype.initItemBrandShopListSp = function(){
	var _this = this;

	$('#morebtn_item_brand_shop_list').on('click', function(event){
		_this.showMoreItemBrandShopList(event);
	});

	// [ブランド]の取り扱いがある店舗のボタン初期化
	this.initializeLocateButton();
};
*/

/**
 * <SP版商品詳細用>
 * [ブランド]の取り扱いがある店舗
 * @method initProductItemDetailListSp
 */
/*
EPK.ProductItemDetail.prototype.initializeLocateButton = function() {
	if (!EPK.ProductItemDetailParams.isSP) {
		return;
	}

	// 置いてあった
	$('.found a.init-locate-btn').on('click.locatebtn', function() {
		if($(this).hasClass('disabled')){
			return false;
		}

		// clickevent削除
		$(this).off('click.locatebtn');

		// ボタン非活性
		$(this).addClass('disabled');
		$(this).parent('li').addClass('off');

		// カウントup
		$count = $(this).find('.locate-btn-counter');
		$count.text(parseInt($count.text()) + 1);

		// url parameters
		var shopId = $(this).data('shopid');
		var url = '/api/product/push_shop_handle_count?shop_id='+shopId+'&brand_id='+EPK.ProductItemDetailParams.ephcItemBrandId;

		// click時の処理記述
		$.ajax({
			type: 'GET',
			url: url,
			cache: false,
			dataType : 'JSON'
		}).done(function(data) {
			//console.log(data);
		}).fail(function() {
			console.log('fail');
		});
	});

	// 置いてほしい！
	$('.want a.init-locate-btn').on('click.locatebtn', function() {
		if($(this).hasClass('disabled')){
			return false;
		}

		// ログイン
		if (EPK.common.isLogin) {
			// clickevent削除
			$(this).off('click.locatebtn');

			// ボタン非活性
			$(this).addClass('disabled');
			$(this).parent('li').addClass('off');

			// カウントup
			$count = $(this).find('.locate-btn-counter');
			$count.text(parseInt($count.text()) + 1);

			// url parameters
			var shopId = $(this).data('shopid');
			var url = '/api/product/push_shop_like_handle_count?shop_id='+shopId+'&brand_id='+EPK.ProductItemDetailParams.ephcItemBrandId;

			// click時の処理記述
			$.ajax({
				type: 'GET',
				url: url,
				cache: false,
				dataType : 'JSON'
			}).done(function(data) {
				//console.log(data);
			}).fail(function() {
				console.log('fail');
			});
		}
		// 未ログイン
		else {
			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {src: $('#modal-locate-btn-guest')},
				type: 'inline',
				modal: true,
			}, 0);
		}
	});

	// event初期化用class削除
	$('.init-locate-btn').removeClass('init-locate-btn');
};
*/

/**
 * リクエストボタンの描画
 *@method renderRequestBtn
 *
 * 必須request_kind shop_ids(配列) item_id
 */
/*
EPK.ProductItemDetail.prototype.renderRequestBtn = function (request_kind,shop_id,flag) {

	var data = {}
	var targetShopId = [];
	var shopId = shop_id;
	var itemId = EPK.common.params.item_id;
	var memberId = EPK.common.member_id;
	var requestContent = flag

	//パラメータの生成
	if (request_kind) {
		data.request_kind = request_kind;
	}

	if (shopId.length > 0) {
		for (var i = 0; i < shopId.length; i++) {
			targetShopId.push(shopId[i].getAttribute('target-shop-id'));
		}

		if (targetShopId.length > 0) {
			data.shop_ids = targetShopId;
		}
	}

	if (itemId) {
		data.item_id = itemId;
	}

	if (memberId) {
		data.member_id = memberId;
	}

	$.ajax({
		type: 'POST',
		url: '/api/product/get_request',
		cache: false,
		dataType : 'JSON',
		data: data,
	}).done(function(data) {

		if (data) {
			var requestData = data;
			Object.keys(requestData).forEach(function (key) {
				var targetElem

				//if (requestContent == 'torioki') {
				//	targetElem = document.querySelectorAll('.torioki-request[target-shop-id="'+ key +'"]');
				//} else if (requestContent == 'zaiko') {
				//	targetElem = document.querySelectorAll('.zaiko-request[target-shop-id="'+ key +'"]');
				//}
				targetElem = document.querySelectorAll('.zaiko-request[target-shop-id="'+ key +'"]');

				if (targetElem.length > 0) {
					if (requestData[key].count) {
						targetElem[0].insertAdjacentHTML('beforeend',requestData[key].count);
					}
					if (requestData[key].button) {
						targetElem[0].insertAdjacentHTML('beforeend',requestData[key].button);
					}
					if (requestData[key].disabled == true) {
						targetElem[0].classList.add('request-completed');
					}

					EPK.ProductItemDetail.prototype.setRequestBtnEvents(targetElem);
				}
			});
		}

	}).fail(function() {
		console.log('fail');
	});
}
*/
/*
EPK.ProductItemDetail.prototype.setRequestBtnEvents = function (targetElem) {

	var data = {};
	var getDataElem,requestCount;
	targetElem[0].addEventListener('click',function (e) {
		if (targetElem[0].classList.contains('request-completed')) {
			return;
		}
		if (!EPK.common.member_id) {
			//ログイン時のモーダル描画
			$.magnificPopup.open({
				items: {
					src: '#modal-product_request_login',
					type: 'inline'
				}
			});
			return;
		} else {
			data.member_id = EPK.common.member_id;
		}

		//リクエストデータの生成
		getDataElem = targetElem[0].querySelectorAll('a');
		requestCount = targetElem[0].querySelectorAll('.count');
		if (getDataElem.length > 0) {

			if (getDataElem[0].getAttribute('target-request-kind')) {
				data.request_kind = getDataElem[0].getAttribute('target-request-kind');
			}

			if (getDataElem[0].getAttribute('target-shop-id')) {
				data.shop_id = getDataElem[0].getAttribute('target-shop-id');
			}

			if (getDataElem[0].getAttribute('target-item-id')) {
				data.item_id = getDataElem[0].getAttribute('target-item-id');
			}
			$.ajax({
				type: 'POST',
				url: '/api/product/set_request',
				cache: false,
				dataType : 'JSON',
				data: data,
			}).done(function(data) {
				if (data) {

					if (data.result === 'success') {
						getDataElem[0].innerHTML = data.button_str;

						//ボタンを非活性
						getDataElem[0].classList.remove('request');
						if(EPK.ProductItemDetailParams.isSP){
							getDataElem[0].classList.add('requested');
						} else {
							getDataElem[0].classList.add('request-comp');
						}
						//リクエスト数の増加
						if (requestCount) {
							requestCount[0].innerHTML = Number(requestCount[0].innerHTML) + 1;
						}
						$.magnificPopup.open({
							items: {
								src: '#modal-product_request_complete',
								type: 'inline'
							}
						});
					} else if (data.result == 'error') {
						$.magnificPopup.open({
							items: {
								src: '#modal-product_request_error',
								type: 'inline'
							}
						});
					}
				}
			}).fail(function() {
				console.log('fail');
			});
		}

	},false);
}
*/

/**
 * 商品×店舗一覧のエリア変更をクリック
 */
EPK.ProductItemDetail.popupAreaClick = function () {

	var pref = $('input:radio[name="radio-prefecture"]:checked').val();

	if (pref) {
		$('input:radio[name="radio-prefecture"]').prop('checked', false);
		$('.bottom-fixed-menu-item-pref .filtering').addClass('disabled');
		$('.bottom-fixed-menu-item-pref .search').addClass('disabled');
	}
};

/**
 * 商品×店舗一覧のエリア変更（都道府県）検索をクリック
 */
EPK.ProductItemDetail.popupAreaItemPrefSeartch = function () {

	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	var itemId = EPK.common.params.item_id;

	var target_url = '';
	if (pref == 'all') {
		target_url = '/product/item/' + itemId;
	} else {
		target_url = '/product/item/' + itemId + '/' + pref + '/list';
	}

	var search_query = EPK.ProductItemDetail.makeSearchQueryForPopupAreaItemPrefCitySeartch();

	window.location.href = target_url + search_query;
};

/**
 * 商品×店舗一覧のエリア変更（都道府県）PC初期表示
 */
EPK.ProductItemDetail.showPCModalsItemPrefList = function () {

	var objSection = $('.modal-checkbox-item-pref');
	var itemId = EPK.common.params.item_id;

	var data = {
		item_id: itemId,
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_item_pref',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$('.bottom-fixed-menu-item-city .search').addClass('disabled');

					// エリア変更（都道府県）エリアをクリック
					$('.modal-checkbox-item-pref input').on('click', function () {
						EPK.ProductItemDetail.popupAreaPrefClick();
					});

					// エリア変更（都道府県）検索をクリック
					$('.bottom-fixed-menu-item-pref .search').on('click', function () {
						EPK.ProductItemDetail.popupAreaItemPrefSeartch();
					});

					// エリア変更（都道府県）さらに絞り込むをクリック
					$('#modal-product-search-item-area-city-btn').on('click', function () {
						EPK.ProductItemDetail.showPCModalsItemAreaList();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * 商品×店舗一覧のエリア変更（都道府県）SP初期表示
 */
EPK.ProductItemDetail.showSPModalsItemPrefList = function () {

	var objSection = $('.popup-scroll-inner-item-pref');
	var itemId = EPK.common.params.item_id;

	var data = {
		item_id: itemId,
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_item_pref',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$('.bottom-fixed-menu-item-city .search').addClass('disabled');

					// エリア変更（都道府県）エリアをクリック
					$('.popup-scroll-inner-item-pref input').on('click', function () {
						EPK.ProductItemDetail.popupAreaPrefClick();
					});

					// エリア変更（都道府県）検索をクリック
					$('.bottom-fixed-menu-item-pref .search').on('click', function () {
						EPK.ProductItemDetail.popupAreaItemPrefSeartch();
					});

					// エリア変更（都道府県）さらに絞り込むをクリック
					$('#modal-product-search-item-area-city-btn').on('click', function () {
						EPK.ProductItemDetail.showSPModalsItemAreaList();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * 商品×店舗一覧のエリア変更（都道府県）エリアをクリック
 */
EPK.ProductItemDetail.popupAreaPrefClick = function () {

	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	if (pref == 'all') {
		$('.bottom-fixed-menu-item-pref .filtering').addClass('disabled');
	} else {
		$('.bottom-fixed-menu-item-pref .filtering').removeClass('disabled');
	}
	$('.bottom-fixed-menu-item-pref .search').removeClass('disabled');
};

/**
 * 商品×店舗一覧のエリア変更（都道府県）PCさらに絞り込むをクリック
 */
EPK.ProductItemDetail.showPCModalsItemAreaList = function () {

	var objSection = $('.modal-location-item-city');
	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	var itemId = EPK.common.params.item_id;

	var data = {
		pref_furi: pref,
		item_id: itemId,
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_item_city',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$("#modal-area-pref").val(pref);
					$('.bottom-fixed-menu-item-city .search').addClass('disabled');

					// エリア変更（市区町村）エリアをクリック
					$('.modal-location-item-city input').on('click', function () {
						EPK.ProductItemDetail.popupAreaItemCityClick();
					});

					// エリア変更（市区町村）検索をクリック
					$('.bottom-fixed-menu-item-city .search').on('click', function () {
						EPK.ProductItemDetail.popupAreaItemCitySeartch();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * 商品×店舗一覧のエリア変更（都道府県）SPさらに絞り込むをクリック
 */
EPK.ProductItemDetail.showSPModalsItemAreaList = function () {

	var floatBtn = document.querySelectorAll('div.mfp-wrap .bottom-fixed-menu');
	//フロートボタンがあるモーダルのみpaddingの対応を入れる。
	if (floatBtn.length > 0) {
		EPK.ProductItemDetail.modalBgScrollControll();
	}

	var objSection = $('.popup-scroll-inner-item-area');
	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	var itemId = EPK.common.params.item_id;

	var data = {
		pref_furi: pref,
		item_id: itemId,
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_item_city',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$("#modal-area-pref").val(pref);
					$('.bottom-fixed-menu-item-city .search').addClass('disabled');

					// エリア変更（市区町村）エリアをクリック
					$('.popup-scroll-inner-item-area input').on('click', function () {
						EPK.ProductItemDetail.popupAreaItemCityClick();
					});

					// エリア変更（市区町村）検索をクリック
					$('.bottom-fixed-menu-item-city .search').on('click', function () {
						EPK.ProductItemDetail.popupAreaItemCitySeartch();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * 商品×店舗一覧のエリア変更（市区町村）エリアをクリック
 */
EPK.ProductItemDetail.popupAreaItemCityClick = function () {

	$('.bottom-fixed-menu-item-city .search').removeClass('disabled');
};

/**
 * 商品×店舗一覧のエリア変更（市区町村）検索をクリック
 */
EPK.ProductItemDetail.popupAreaItemCitySeartch = function () {

	var city = $('input:radio[name="radio-city"]:checked').val();
	var pref = $("#modal-area-pref").val();
	var itemId = EPK.common.params.item_id;

	var target_url = '/product/item/' + itemId + '/' + pref + '/list/' + city;

	var search_query = EPK.ProductItemDetail.makeSearchQueryForPopupAreaItemPrefCitySeartch();

	window.location.href = target_url + search_query;
};

EPK.ProductItemDetail.makeSearchQueryForPopupAreaItemPrefCitySeartch = function () {
	var params = {};
	var search_query = '';
	if(location.search){
		var query = location.search.replace('?', '');
		var list = query.split('&');
		for (i in list) {
			var array = list[i].split('=');

			if(array[0] != 'p'){
				params[i] = array;
			}
		}
	}

	if(params){
		for (i in params) {
			if(i == 0){
				search_query += '?';
			}else{
				search_query += '&';
			}

			search_query += params[i][0] + '=' + params[i][1];
		}
	}

	return search_query;
};

EPK.ProductItemDetail.modalBgScrollControll = function (floatBtn) {

	//モーダル表示中bodyscroll制御
	var scrollPosition = window.pageYOffset;
	var closeBtn = document.getElementsByClassName('popup-close-btn');
	var floatBtn = document.querySelectorAll('div.mfp-wrap .bottom-fixed-menu');
	//フロートボタンがあるモーダルのみpaddingの対応を入れる。
	if (floatBtn.length > 0) {

		var modal,scrollElem,windowHeight,modalStyle,modalPaddingBottom,clientRect;
		modal = document.getElementById('modal-product-search-choise-area-pref');
		scrollElem = document.querySelectorAll('div.mfp-wrap ul.popup-scroll-inner');

		if (modal && scrollElem.length > 0) {
			modalStyle = getComputedStyle(scrollElem[0],null);
			floatBtnStyle = getComputedStyle(floatBtn[0],null);
			modalPaddingBottom = Number(modalStyle.paddingBottom.replace(/px/g , ""));
			//cssのpaddingと比較していかっだった場合にpaddingをつける
			if (modalPaddingBottom <= 120) {
				floatBtnHeight = Number(floatBtnStyle.height.replace(/px/g , ""));
				scrollElem[0].style.paddingBottom = (modalPaddingBottom + floatBtnHeight) + 'px';
			}

		}

	}
	document.body.style.position = 'fixed';
	if (closeBtn.length > 0) {
		[].forEach.call(closeBtn,function(elem) {

			elem.addEventListener('click',function() {
				scrollElem = document.querySelectorAll('ul.popup-scroll-inner');
				if (scrollElem.length > 0) {
					for (var i = 0; i < scrollElem.length; i++) {
						scrollElem[i].style.paddingBottom = '';
					}
				}
				document.body.style.position = '';
				window.scrollTo(0,scrollPosition);
			},false);
		})
	}
}

/**
 * カテゴリーのEPARKポイント交換割引クーポンが使える商品取得
 */
 EPK.ProductItemDetail.prototype.setItemEpkPtExchCpListArea = function() {
	var objSection = $('.slide-contents-item-epkptexchcp');

	var data = {
		'category_id': EPK.ProductItemDetailParams.category_id,
		'pref_cd': EPK.ProductItemDetailParams.prefCd,
		'area_id': EPK.ProductItemDetailParams.areaId
	}

	$.ajax({
		url: '/api/product/set_item_epkptexchcp_list_area',
		type: 'GET',
		data: data,
		cache: false,
		dataType: "html",
	}).done(function (data) {
		objSection.empty();
		objSection.append(data);
		EPK.ProductItemDetail.sliderInit('product-slider-epkptexchcp');
	}).fail(function (data) {
		console.log('failed');
	});
};

/**
 * カテゴリーのおすすめ商品取得
 */
EPK.ProductItemDetail.prototype.setItemRecommendedListArea = function() {
	var objSection = $('.slide-contents-item-recommended');

	var data = {
		'category_id': EPK.ProductItemDetailParams.category_id,
		'pref_cd': EPK.ProductItemDetailParams.prefCd,
		'area_id': EPK.ProductItemDetailParams.areaId
	}

	$.ajax({
		url: '/api/product/set_item_recommended_list_area',
		type: 'GET',
		data: data,
		cache: false,
		dataType: "html",
	}).done(function (data) {
		objSection.empty();
		objSection.append(data);

		if(EPK.ProductItemDetailParams.isSP){
			EPK.ProductCommon.getMinPrice('recommend', 8, 1);
		}else{
			EPK.ProductCommon.getMinPrice('recommend', 9, 1);
		}

		EPK.ProductItemDetail.sliderInit('product-slider-recommend');
	}).fail(function (data) {
		console.log('failed');
	});
};

/**
 * スライダー
 * 前ページボタン、次ページボタン
 */
EPK.ProductItemDetail.sliderInit = function (className) {
	// PC版のみ
	if(!EPK.ProductItemDetailParams.isSP){
		// 5枚以下　ループさせない、ボタン表示させない。
		// 6枚以上　ループさせる、ボタン表示させる。
		var productSlider = document.getElementsByClassName(className);
		if (productSlider.length > 0) {
			var sliderContents = document.querySelectorAll('div.' + className + ' .swiper-wrapper .swiper-slide');
			if (sliderContents.length > 5) {
				$('.' + className).swiper({
					loop: true,
					slidesPerView: 'auto',
					nextButton: '.slider-fwd',
					prevButton: '.slider-rev',
					pagination: '.slider-count',
					paginationType: 'fraction',
				});
				if (className == 'product-slider-recommend') {
					EPK.ProductCommon.getMinPrice('recommend', 9, 1);
				}
			}
		}
	}
};

$(function(){

	var ProductItemDetail = new EPK.ProductItemDetail();

	// ポイントバルーン
	//ProductItemDetail.setBalloonElsStyle();
	//$(window).on('resize', function() {
	//	ProductItemDetail.setBalloonElsStyle();
	//});

	ProductItemDetail.getLocation();

	ProductItemDetail.setItemEpkPtExchCpListArea();

	ProductItemDetail.setItemRecommendedListArea();

	$('#sort_normal').on('click', function() {
		ProductItemDetail.getSortNormal();
	});

	$('#sort_close').on('click.sort_close', function() {
		// クリック時に明示的に緯度経度を取得し直す
		ProductItemDetail.getLocation();
	});

	/**
	 * 以下SP版のみ
	 */
	if(EPK.ProductItemDetailParams.isSP){

		//＃14698sp版cssの遅延読み込み
		var asyncAddCss = document.querySelectorAll('input[type="hidden"][class="async-add-css"]');
		if (asyncAddCss.length > 0) {
			for (var i = 0; i < asyncAddCss.length; i++) {
				var css = asyncAddCss[i].value;
				asyncAddCss[i].insertAdjacentHTML('afterend',css);
			}
		}

		var $slider_items = $('#slider-items');
		var loopFlag = $(".swiper-slide").length > 1 ? true : false;
		if($slider_items.find(".swiper-slide").length > 0){
			var swiper = $slider_items.swiper({
				loop:loopFlag,
				centeredSlides: true,
				slidesPerView: 1,
				pagination: '.swiper-pagination',
				paginationClickable: true,
				preloadImages:false,
				lazyLoading:true,
				lazyLoadingOnTransitionStart:true,
			});
		}

		$.Deferred().resolve()
		.then(function () {
			return ProductItemDetail.setItemMinPriceAreaSp();
		}).then(function (data) {
			var $slider_change_lot_button = $('#slider-change_lot_button');
			if($slider_change_lot_button.find(".swiper-slide").length > 0){
				var swiper = $slider_change_lot_button.swiper({
					slidesPerView: 'auto',
					freeMode: true,
				});
			}
		});


		//ProductItemDetail.setItemGroupArea();

		//カセット部分非同期取得 カセットを取得してからアフィリエイトを取得
		$.Deferred().resolve()
		.then(function(){
			return ProductItemDetail.getItemShopList();
		}).then(function (data) {
			ProductItemDetail.setAffiliateInfo();
			ProductItemDetail.initProductShopItemListSp();
		});


		//ProductItemDetail.initProductShopItemListSp();

		//ProductItemDetail.initItemBrandShopListSp();

		//ProductItemDetail.initializeLocateButton();

		// 商品×店舗一覧のエリア変更をクリック
		$('.modal-product-search-item-area-pref-btn').on('click', function () {
			EPK.ProductItemDetail.popupAreaClick();
			EPK.ProductItemDetail.showSPModalsItemPrefList();

			EPK.ProductItemDetail.modalBgScrollControll();
		});

	/**
	 * 以下PC版のみ
	 */

	}else{

		ProductItemDetail.setItemMinPriceAreaPc();

		//PC版　アフィリエイト(SP版がカセット部分との直列処理のため共通処理に入れない)
		ProductItemDetail.setAffiliateInfo();

		// サムネイルの変更処理
		if ($('.subImg').length > 0 && $('#mainImg').length > 0) {
			var mainImg = $('#mainImg');
			var subImg = $('.subImg');
			subImg.mouseenter('thumbChange',function () {
				var $this = $(this);
				var onMouseImg = $this.attr('src');
				subImg.each(function (i,el) {
					if ($(el).closest('li').hasClass('is-active')) {
						$(el).closest('li').removeClass('is-active');
					}
				});
				$this.closest('li').addClass('is-active');
				mainImg.attr('src',onMouseImg);
			});
		}

		// 「店舗在庫数について」モーダル
		$('.product-shop .shop-header .stock').on('click', function (event) {
			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {src: '#modal_stock_num'},
				type: 'inline',
				modal: false,
				showCloseBtn: false
			}, 0);
		});

		// 「店舗在庫状況について」モーダル
		$('.linkStockModal').on('click', function (event) {
			// モーダルテキスト書き換え
			$('#modal_stock_situation .shopname').text(event.currentTarget.dataset.shopname);
			$('#modal_stock_situation .tel').text(event.currentTarget.dataset.tel);
			$('#modal_stock_situation .time').text('営業時間 ' +event.currentTarget.dataset.opentime);
			if (event.currentTarget.dataset.holiday != 'なし') {
				$('#modal_stock_situation .time').append('（'+ event.currentTarget.dataset.holiday +'定休）');
			}
			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {src: '#modal_stock_situation'},
				type: 'inline',
				modal: false,
				showCloseBtn: false
			}, 0);
		});

		// PC版　メーカーリスト取得
		//ProductItemDetail.getMakerList();

		// PC版　カテゴリーレコメンド取得
		//ProductItemDetail.getCategoryRecommendList();

		// 商品×店舗一覧のエリア変更をクリック
		$('.modal-product-search-item-area-pref-btn').on('click', function () {
			EPK.ProductItemDetail.popupAreaClick();
			EPK.ProductItemDetail.showPCModalsItemPrefList();
		});
	}

	//リクエストボタンの描画
	// 2020-08-26 del
	//var toriokiRequestShopId = document.querySelectorAll('.torioki-request[target-shop-id]');
	//if (toriokiRequestShopId.length > 0) {
	//	//ProductItemDetail.renderRequestBtn('1',toriokiRequestShopId,'torioki')
	//}

	//var zaikoRequestShopId = document.querySelectorAll('.zaiko-request[target-shop-id]');
	//if (zaikoRequestShopId.length > 0) {
	//	ProductItemDetail.renderRequestBtn('2',zaikoRequestShopId,'zaiko');
	//}
});
